import { Component, Input } from '@angular/core';

@Component({
  selector: 'ad-hoc-filter-text',
  template: require('./adhoc.filter.text.component.html'),
})
export class AdHocFilterTextComponent {
  @Input() filter: any;

  constructor() {}

}
